

const InfoBox = () => {
    return(
        <>
            <p className='Info-p'>
                This is an estimation of the battery’s lifespan. 
                The higher estimations may have a greater chance that it may be inaccurate, 
                due to factors that are difficult to calculate and control. 
                Read more <a href="https://sensative.com/sensors/strips-sensors-for-lorawan/sensative-strips-lora-battery-calculator/">here.</a>
            </p>
        </>
    )
}

export default InfoBox;